// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".movies-grid-item .badge .background {\n  color: #90cdf4;\n}\n.movies-grid-item .badge .icon-watched {\n  display: none;\n}\n.movies-grid-item .badge:hover .background, .movies-grid-item .badge.watched .background {\n  color: #ade368;\n}\n.movies-grid-item .badge:hover .icon-watched, .movies-grid-item .badge.watched .icon-watched {\n  display: block;\n}\n.movies-grid-item .badge:hover .icon-pending, .movies-grid-item .badge.watched .icon-pending {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
